export const TableStyles = {
  // IDs like Verve ID, Employee ID
  idCell: "text-[13px] text-slate-700 whitespace-nowrap font-normal",
  
  // Primary prominent text (Names, Titles)
  primaryText: "text-[13px] text-slate-800 leading-tight truncate font-normal",
  
  // Secondary text (Emails, Phones, Subtitles)
  secondaryText: "text-xs text-slate-500 truncate font-normal",
  
  // Tag-like texts (Source, Type)
  badge: "text-[10px] text-slate-600 uppercase tracking-wider bg-slate-100 px-2 py-1 rounded-md font-normal",
  
  // Note text
  noteText: "text-xs text-slate-500 italic block py-1 font-normal",
  
  // Standard regular text (Locations, Phones, generic info)
  regularText: "text-[13px] text-slate-600 truncate font-normal",
  
  // Action icons
  actionIcon: "text-slate-400 hover:text-brand-blue cursor-pointer transition-colors font-normal"
};
